import { DESKTOP_LIST_WIDTH_POURC } from "../../constants";
import { ViewportProps } from "react-map-gl";

export const getDefaultViewport = (isMobile?: boolean): ViewportProps => {
  return {
    latitude: 37.06760258527157,
    longitude: -119.23111051613962,
    zoom: isMobile ? 4.5 : 5.5,
    width: null,
    height: null,
    bearing: 0,
    pitch: 0,
    altitude: 1.5,
    maxZoom: 24,
    minZoom: 0,
    maxPitch: 0,
    minPitch: 0
  };
};

export const getMapWidthToEdge = (containerWidth?: string) => {
  const containerPadding = 8 * 8;
  // prettier-ignore
  const containerWidthNoPadding = `calc(${containerWidth} - ${containerPadding * 2}px)`;
  // prettier-ignore
  return `calc((${containerWidthNoPadding} * (${(100 - DESKTOP_LIST_WIDTH_POURC) / 100}) ) + (100vw - ${containerWidthNoPadding}) / 2)`;
};
